import React, { Component } from 'react';
import { Row, Col } from 'antd';
import { LINK_ANDROID_APP, LINK_IOS_APP } from '../../containers/HeaderContainer/constants';
import endPoints from '../../config/endPoints';
import LandingContainer from '../../components/LandingContainer';

class PartnerBannersApp extends Component {
  componentDidMount() {
    this.redirectToAppStore();
  }

  redirectToAppStore() {
    const isAndroid = navigator.userAgent.toLowerCase().indexOf('android') > -1;
    const isiPhone = navigator.userAgent.toLowerCase().indexOf('iphone') > -1;

    if (isAndroid) {
      window.location.href = 'https://play.google.com/store/apps/details?id=com.zaggle';
    }

    if (isiPhone) {
      window.location.href = 'https://itunes.apple.com/in/app/zaggle/id1030365320?mt=8';
    }
  }

  render() {
    return (
      <LandingContainer>
        <Row type="flex" align="middle" justify="center" className="padding-t-9 margin-b-9">
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center">
            <h1>Download Mobile app</h1>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center">
            <a target="_blank" href={LINK_ANDROID_APP}>
              <img className="width-3 rounded" src={endPoints.ZAGGLE_PLAY_STORE.URL} alt={endPoints.ZAGGLE_PLAY_STORE.ALT} />
            </a>
            <a target="_blank" href={LINK_IOS_APP}>
              <img className="width-3 rounded margin-l-2" src={endPoints.ZAGGLE_APP_STORE.URL} alt={endPoints.ZAGGLE_APP_STORE.ALT} />
            </a>
          </Col>
        </Row>
      </LandingContainer>
    );
  }
}

export default PartnerBannersApp;



// WEBPACK FOOTER //
// client/containers/PartnerBanners/partnerBannersApp.jsx